import { createAction } from 'redux-actions';

export const getFilters = createAction('GET_FILTERS');
export const getFiltersSuccess = createAction('GET_FILTERS_SUCCESS');
export const getFiltersFailure = createAction('GET_FILTERS_FAILURE');

export const createFilter = createAction('CREATE_FILTER');
export const createFilterSuccess = createAction('CREATE_FILTER_SUCCESS');
export const createFilterFailure = createAction('CREATE_FILTER_FAILURE');

export const updateFilter = createAction('UPDATE_FILTER');
export const updateFilterSuccess = createAction('UPDATE_FILTER_SUCCESS');
export const updateFilterFailure = createAction('UPDATE_FILTER_FAILURE');

export const deleteFilter = createAction('DELETE_FILTER');
export const deleteFilterSuccess = createAction('DELETE_FILTER_SUCCESS');
export const deleteFilterFailure = createAction('DELETE_FILTER_FAILURE');
